/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WebhooksIndexRouteImport } from './routes/webhooks.index'
import { Route as TriggerIndexRouteImport } from './routes/trigger.index'
import { Route as TemplatesIndexRouteImport } from './routes/templates.index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as RunsIndexRouteImport } from './routes/runs.index'
import { Route as EnvVaultIndexRouteImport } from './routes/env-vault.index'
import { Route as WebhooksWebhookIdRouteImport } from './routes/webhooks_.$webhookId'
import { Route as RunsRunIdRouteImport } from './routes/runs.$runId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WebhooksIndexRoute = WebhooksIndexRouteImport.update({
  id: '/webhooks/',
  path: '/webhooks/',
  getParentRoute: () => rootRouteImport,
} as any)
const TriggerIndexRoute = TriggerIndexRouteImport.update({
  id: '/trigger/',
  path: '/trigger/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsIndexRoute = RunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => rootRouteImport,
} as any)
const EnvVaultIndexRoute = EnvVaultIndexRouteImport.update({
  id: '/env-vault/',
  path: '/env-vault/',
  getParentRoute: () => rootRouteImport,
} as any)
const WebhooksWebhookIdRoute = WebhooksWebhookIdRouteImport.update({
  id: '/webhooks_/$webhookId',
  path: '/webhooks/$webhookId',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsRunIdRoute = RunsRunIdRouteImport.update({
  id: '/runs/$runId',
  path: '/runs/$runId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/runs/$runId': typeof RunsRunIdRoute
  '/webhooks/$webhookId': typeof WebhooksWebhookIdRoute
  '/env-vault/': typeof EnvVaultIndexRoute
  '/runs/': typeof RunsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/trigger/': typeof TriggerIndexRoute
  '/webhooks/': typeof WebhooksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/runs/$runId': typeof RunsRunIdRoute
  '/webhooks/$webhookId': typeof WebhooksWebhookIdRoute
  '/env-vault': typeof EnvVaultIndexRoute
  '/runs': typeof RunsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/trigger': typeof TriggerIndexRoute
  '/webhooks': typeof WebhooksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/runs/$runId': typeof RunsRunIdRoute
  '/webhooks_/$webhookId': typeof WebhooksWebhookIdRoute
  '/env-vault/': typeof EnvVaultIndexRoute
  '/runs/': typeof RunsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/trigger/': typeof TriggerIndexRoute
  '/webhooks/': typeof WebhooksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/runs/$runId'
    | '/webhooks/$webhookId'
    | '/env-vault/'
    | '/runs/'
    | '/settings/'
    | '/templates/'
    | '/trigger/'
    | '/webhooks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/runs/$runId'
    | '/webhooks/$webhookId'
    | '/env-vault'
    | '/runs'
    | '/settings'
    | '/templates'
    | '/trigger'
    | '/webhooks'
  id:
    | '__root__'
    | '/'
    | '/runs/$runId'
    | '/webhooks_/$webhookId'
    | '/env-vault/'
    | '/runs/'
    | '/settings/'
    | '/templates/'
    | '/trigger/'
    | '/webhooks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  RunsRunIdRoute: typeof RunsRunIdRoute
  WebhooksWebhookIdRoute: typeof WebhooksWebhookIdRoute
  EnvVaultIndexRoute: typeof EnvVaultIndexRoute
  RunsIndexRoute: typeof RunsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
  TriggerIndexRoute: typeof TriggerIndexRoute
  WebhooksIndexRoute: typeof WebhooksIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhooks/': {
      id: '/webhooks/'
      path: '/webhooks'
      fullPath: '/webhooks/'
      preLoaderRoute: typeof WebhooksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trigger/': {
      id: '/trigger/'
      path: '/trigger'
      fullPath: '/trigger/'
      preLoaderRoute: typeof TriggerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/': {
      id: '/runs/'
      path: '/runs'
      fullPath: '/runs/'
      preLoaderRoute: typeof RunsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/env-vault/': {
      id: '/env-vault/'
      path: '/env-vault'
      fullPath: '/env-vault/'
      preLoaderRoute: typeof EnvVaultIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhooks_/$webhookId': {
      id: '/webhooks_/$webhookId'
      path: '/webhooks/$webhookId'
      fullPath: '/webhooks/$webhookId'
      preLoaderRoute: typeof WebhooksWebhookIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/$runId': {
      id: '/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/runs/$runId'
      preLoaderRoute: typeof RunsRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  RunsRunIdRoute: RunsRunIdRoute,
  WebhooksWebhookIdRoute: WebhooksWebhookIdRoute,
  EnvVaultIndexRoute: EnvVaultIndexRoute,
  RunsIndexRoute: RunsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
  TriggerIndexRoute: TriggerIndexRoute,
  WebhooksIndexRoute: WebhooksIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
